import { render } from "./PulseiraBadge.vue?vue&type=template&id=1451aac6&scoped=true"
import script from "./PulseiraBadge.vue?vue&type=script&lang=js"
export * from "./PulseiraBadge.vue?vue&type=script&lang=js"

import "./PulseiraBadge.vue?vue&type=style&index=0&id=1451aac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1451aac6"]])

export default __exports__